/**
 @format
 @flow
 */

import React from 'react';
import styled from 'styled-components';
import { VideoSquare } from '@ziynx/components/media';
import Headline from '@ziynx/components/headlines';
import CardBase from './CardBase';

export type Props = $ReadOnly<{|
  /**
   * Optional width,
   */
  width?: string,
  /**
   * Optional height. Default auto
   */
  height?: string,
  /**
   * Video source
   */
  src?: string,
  /**
   * Optional headline above card
   */
  title?: string,
  /**
   * Custom function fired when video is played
   */
  onPlay?: () => void,
  /**
   * Image overlay source
   */
  imageSource?: string,
  size?: string,
|}>;

const getSize = (size) => {
  let cardSize;

  switch (size) {
  case 'small':
    cardSize = '382px';
    break;
  case 'medium':
    cardSize = '520px';
    break;
  case 'large':
    cardSize = '688px';
    break;
  case 'extraSmall':
  default:
    cardSize = '288px';
    break;
  }
  return cardSize;
};

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const HeadlineWrapper = styled.div`
  display: flex;
  justify-content: center; 
  width: 100%;
  padding-bottom: 24px;
`;

const CardVideoSquare = (props: Props): React$Node => {
  const {
    size, width, height, src, title, imageSource, onPlay, ...rest
  } = props;

  if (!src || !imageSource) return null;
  return (
    <CardWrapper>
      {title
      && (
        <HeadlineWrapper>
          <Headline>
            {title}
          </Headline>
        </HeadlineWrapper>
      )}
      <CardBase width={size ? getSize(size) : 'auto'} height={size ? getSize(size) : 'auto'}>
        { (!!src || !!imageSource)
          && (
            <VideoSquare
              onPlay={onPlay}
              boxShadow={false}
              videoSource={src}
              imageSource={imageSource}
              {...rest}
            />
          )}
      </CardBase>
    </CardWrapper>
  );
};

CardVideoSquare.defaultProps = {
  height: 'auto',
  size: undefined,
};

export default CardVideoSquare;
